<template>
  <div class="gallery-box">
    <div class="image">
      <img :src="require('../../assets/gallery/'+imgSrc)">
    </div>
    <div class="gallery-text-wrapper">
      <div class="title">
        {{title}}
      </div>
      <p class="text">
        {{name}}
      </p>
    </div>
  </div>
</template>

<script>
import users from '../../assets/gallery/gallery-list.json'

export default {
  name: 'gallery-box',
  props: {
    p_id: String
  },
  data () {
    return {
      title: users[this.p_id]['place'],
      name: users[this.p_id]['place_e'],
      imgSrc: users[this.p_id]['imgSrc']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .gallery-box{
    height: 100%;
    text-align: left;
    overflow: hidden;

    a,a:visited{
      text-decoration: none;
    }
  }
  .image{
    width: 100%;

    img{
      width: 100%;
      height: auto;
    }
  }
  .title{
    color: #fff;
    font-size: 1.5vw;
    font-weight: bold;
    text-align: left;
  }
  .text{
    margin: 0;
    color: #fff;
    font-size: 1.5vw;
    font-weight: bold;
    text-align: left;
  }
  .gallery-text-wrapper{
    margin-left: 1vw;
    margin-top: -5vw;
  }
  @media (max-width: 550px){
    .title{
      font-size: 18px;
    }
    .text{
      font-size: 18px;
    }
    .gallery-text-wrapper{
      margin-left: 5px;
      margin-top: -60px;
    }
  }

</style>
